import { render, staticRenderFns } from "./EpsCart.vue?vue&type=template&id=2b97dfbc"
import script from "./EpsCart.js?vue&type=script&lang=js&external"
export * from "./EpsCart.js?vue&type=script&lang=js&external"
import style0 from "./EpsCart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports